export default {"src":"/_next/static/media/home-unlimited-proofs.92cd503c.svg","height":65,"width":58,"blurWidth":0,"blurHeight":0};